import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");
  return $setup.theme.showRefresh ? (_openBlock(), _createBlock(_component_vab_icon, {
    key: 0,
    icon: "refresh-line",
    onClick: $setup.refreshRoute
  })) : _createCommentVNode("v-if", true);
}